package fyi.moko.hotpl.data.service

import fyi.moko.hotpl.domain.service.HomeViewPreference
import kotlinx.browser.localStorage
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * `localStorage`-backed [HomeViewPreference]. Defensive the same way [JsChangelogStore] is —
 * private browsing or a full quota makes localStorage throw, and a remembered tab is not
 * worth taking the screen down for.
 */
class JsHomeViewPreference : HomeViewPreference {
    private val _mapFirst = MutableStateFlow(load())
    override val mapFirst = _mapFirst.asStateFlow()

    override suspend fun setMapFirst(value: Boolean) {
        _mapFirst.value = value
        try {
            localStorage.setItem(KEY, value.toString())
        } catch (e: Throwable) {
            console.error("Failed to persist the home view preference to localStorage", e)
        }
    }

    private fun load(): Boolean = try {
        localStorage.getItem(KEY) == "true"
    } catch (e: Throwable) {
        console.error("Failed to read the home view preference from localStorage", e)
        false
    }

    private companion object {
        const val KEY = "hotpl_home_map_first"
    }
}
